module.exports = __webpack_public_path__ + "static/media/MainBarTablet.5ca39526.png";